import { render } from "./BottomListTagsAndPhotosView.vue?vue&type=template&id=21390034&scoped=true"
import script from "./BottomListTagsAndPhotosView.vue?vue&type=script&lang=js"
export * from "./BottomListTagsAndPhotosView.vue?vue&type=script&lang=js"

import "./BottomListTagsAndPhotosView.vue?vue&type=style&index=0&id=21390034&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21390034"]])

export default __exports__